import { CellAction } from "./cell-action";

import { ColumnDef } from "@tanstack/react-table";
import { showDate } from "../../../lib/dateFormater";
const uploadUrl = process.env.REACT_APP_FILE_UPLOAD;

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "title",
    header: "TITRE",
  },
  {
    accessorKey: "image",
    header: "IMAGE",
    cell: ({ row }) => (
      <img
        src={`${uploadUrl}/events/${row.original.image}`}
        alt={`Image for ${row.original.image}`}
        className="w-16 rounded-lg h-14"
      />
    ),
  },

  {
    accessorKey: "description",
    header: "DESCRIPTION",
    cell: ({ row }) => {
      const message = row.original.description;
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = message;
      const plainText = tempDiv.textContent || tempDiv.innerText || "";
      return plainText.length > 10 ? `${plainText.slice(0, 10)}...` : plainText;
    },
  },

  {
    accessorKey: "date",
    header: "DATE",
    cell: ({ row }) => {
      return showDate(row.original.date);
    },
  },

  {
    accessorKey: "actions",
    header: "ACTIONS",
    id: "actions",
    cell: ({ row }) => <CellAction data={row.original} />,
  },
];
